export default __webpack_public_path__ + "static/media/activity_visit.ba578b99.svg";